export const fxgBaseApi = '/authorizations/v1/fxg';

export const routes = Object.freeze({
  home: '/home',
  myActions: '/my-actions',
  manageDigitalAssets: '/manage-digital-assets',
  manageDigitalAssetsFxAccount: '/manage-digital-assets/fx-account',
  manageContacts: '/manage-contacts',
  manageContactsContactInfo: '/manage-contacts/contact-information',
  userDetails: '/user-details',
  help: 'help',
});

export const apiPaths = Object.freeze({
  saveUserAccountSetting: `${fxgBaseApi}/user/account-settings/save`,
  timeZoneGetList: `${fxgBaseApi}/timezones`,
  getFxAccounts: `${fxgBaseApi}/digital-assets/fx-account`,
  updateContactDetails: `${fxgBaseApi}/update/contact`,
  userActions: `${fxgBaseApi}/actions`,
  getDialCodes: `${fxgBaseApi}/dial-codes`,
  getContacts: `${fxgBaseApi}/contacts`,
  getAmexContacts: `${fxgBaseApi}/amex-contacts`,
  getActionTypes: `${fxgBaseApi}/action-types`,
  getStatus: `${fxgBaseApi}/status-types`,
  getRequestId: `${fxgBaseApi}/getreqs/`,
  activateFxAccount: `${fxgBaseApi}/fx-account/activate`,
});
